// @flow
import * as React from 'react';
import { capitalize } from 'lodash';

import { statusToTextBadge } from 'admin/constants/AutoMessages';
import Divider from 'components/Divider';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Text from 'components/Text';
import TextBadge from 'components/TextBadge';
import WizardSteps from 'components/WizardSteps';

import type { WizardStepNode } from 'components/WizardSteps';
import type { AutoMessageStatus } from 'queries/__generated__/globalGQLTypes';

type Props = {
  messageName: ?string,
  status: AutoMessageStatus,
  selectedOrgName: string,
  nodes: WizardStepNode[],
  onClickNode: Function,
};

export default class AdminNewAutoMessageFormSidebar extends React.PureComponent<Props, void> {
  render() {
    const { selectedOrgName, messageName, status, nodes, onClickNode } = this.props;

    return (
      <Text align="left">
        <Heading level="2">
          <Text weight="semibold">{messageName || 'Untitled'}</Text>
        </Heading>
        <Row size="small">
          <Text color="thunder" size="medium" truncate>
            {selectedOrgName}
          </Text>
        </Row>
        <TextBadge
          color={statusToTextBadge[status].color}
          textColor={statusToTextBadge[status].textColor}
          textWeight="normal">
          {capitalize(status)}
        </TextBadge>
        <Divider />
        <WizardSteps nodes={nodes} onClickNode={onClickNode} />
      </Text>
    );
  }
}
